export default __webpack_public_path__ + "static/media/BannerIcon.68273eaa.svg";